import { useQuery } from "react-query";
import axios from "infra/http";
import { AreaComumDisponibilidadeResponse } from "../typings";

function useFindDisponibilidadeAreaComum(tenantId: string, id: string) {
  return useQuery(
    `/v1/tenants/${tenantId}/area-comum/${id}/disponibilidade`,
    async () => {
      const { data } = await axios.get<AreaComumDisponibilidadeResponse>(
        `/v1/tenants/${tenantId}/area-comum/${id}/disponibilidade`
      );

      return data;
    },
    {
      enabled: !!id && !!tenantId,
    }
  );
}

export default useFindDisponibilidadeAreaComum;
